import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import logosua from "../img/logo.png";

function RecuperarContrasena() {
  const [correo, setCorreo] = useState("");
  const [mensaje, setMensaje] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      const url = `https://suadesarrollo.azurewebsites.net/api/ActualizaUsuarios/GenerarRestablecerContrasena/${encodeURIComponent(
        correo,
      )}`;
      const res = await axios.put(url);
      setMensaje("Se ha enviado un enlace de restablecimiento a tu correo.");
    } catch (error) {
      setMensaje("Error al enviar el enlace. Verifica el correo.");
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-12">
                  <center>
                    <img src={logosua} width={100} />
                  </center>
                  <div className="p-5">
                    <div className="text-center">
                      <h1 className="h4 text-gray-900 mb-2">
                        ¿Olvidaste la contraseña?
                      </h1>
                      <p className="mb-4">
                        Ingresa tu correo electrónico y te enviaremos un enlace
                        para restablecerla.
                      </p>
                    </div>
                    <form className="user" onSubmit={handleReset}>
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control form-control-user"
                          id="CORREO"
                          placeholder="Correo electrónico"
                          value={correo}
                          onChange={(e) => setCorreo(e.target.value)}
                          required
                        />
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary btn-user btn-block"
                      >
                        Restablecer
                      </button>
                    </form>
                    {mensaje && <p className="mt-3 text-center">{mensaje}</p>}
                    <hr />
                    <div className="text-center">
                      <Link to="/">¿Ya tienes cuenta? ¡Entra!</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecuperarContrasena;
